import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    disabledForLoadingTooltip: translate({ id: 'global.gpsLoading.disableEdit' }),
    searchPlaceholder: translate({ id: 'gps.places.list.filterPlaceholder' }),
    yourPlaces: translate({ id: 'gps.places.list.yourPlaces' }),
    createNew: translate({ id: 'gps.places.createNew' }),
    entitiesCount: (count: number, selected: number): string =>
      translate({
        id:
          selected > 0 ? 'gps.places.list.footerCountWithSelection' : 'gps.places.list.footerCount',
        values: { count, selected },
      }),
    selectBtn: (allSelected: boolean): string =>
      translate({ id: allSelected ? 'global.deselectAll' : 'global.selectAll' }),
    visibilityBtn: (someVisible?: boolean): string =>
      translate({
        id: someVisible ? 'global.hideAll' : 'global.showAll',
      }),

    noEntries: {
      title: translate({ id: 'places.list.noEntries.title' }),
      description: translate({ id: 'places.list.noEntries.description' }),
      action: translate({ id: 'places.list.noEntries.action' }),
    },
    noResults: {
      title: translate({ id: 'places.list.noResults.title' }),
      description: translate({ id: 'places.list.noResults.description' }),
    },
  }))

  return api
}
